import { render, staticRenderFns } from "./org-pro-plus-plan.vue?vue&type=template&id=1ec0897a&scoped=true&"
import script from "./org-pro-plus-plan.vue?vue&type=script&lang=js&"
export * from "./org-pro-plus-plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec0897a",
  null
  
)

export default component.exports